import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { t } from "../../common/LocalizationProvider";

const useStyles = makeStyles((theme) => ({
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: theme.palette.grey[100], // Corresponds to #f5f5f5 or similar
        padding: theme.spacing(2), // General padding
        textAlign: 'center', // Center text for all content within
    },
    contentCard: {
        padding: theme.spacing(4, 3), // Vertical, Horizontal padding
        maxWidth: 500,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: theme.shadows[3],
        [theme.breakpoints.down('xs')]: { // for screens smaller than 'sm' (extra small)
            padding: theme.spacing(3, 2),
            boxShadow: 'none', // Optionally remove shadow on very small screens
            backgroundColor: 'transparent', // Optionally make paper transparent on xs
        },
    },
    icon: {
        fontSize: '3rem', // Large icon
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.main, // Use theme's primary color for the icon
    },
    title: {
        fontWeight: 600,
        marginBottom: theme.spacing(2), // 2 * 8px = 16px (original was 2rem)
        fontSize: '2.2rem', // Original was 2.5rem
        [theme.breakpoints.down('sm')]: { // Corresponds to @media (max-width: 768px) roughly
            fontSize: '1.8rem', // Original was 2rem
            marginBottom: theme.spacing(1.5),
        },
    },
    message: {
        fontSize: '1.1rem', // Original was 1.2rem
        lineHeight: 1.6,    // Original was 1.5
        color: theme.palette.text.secondary,
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.95rem', // Original was 1rem
        },
    },
}));

const CheckEmailMessage = () => {
    const classes = useStyles();

    return (
        <Container component="main" maxWidth={false} className={classes.pageContainer}>
            <Paper className={classes.contentCard} elevation={3}>
                <MailOutlineIcon className={classes.icon} />
                <Typography component="h1" variant="h4" className={classes.title}>
                    {t('ResetPassword')}
                </Typography>
                <Typography component="p" variant="body1" className={classes.message}>
                    {t('ResetPasswordInstructions')}
                </Typography>
            </Paper>
        </Container>
    );
}

export default CheckEmailMessage;